export interface UserProgress {
  level: number;
  xp: number;
  xpNextLevel: number;
  icon: string | null;
  availableAtSettlementLevel: number;
  lastPandaFedAt?: number | null;
}

export interface FeedPandaResponse {
  cookie: { text: string; image: string };
  message: string;
}

export enum UserProgressTagType {
  CURRENT_USER_PROGRESS = 'CurrentUserProgress',
  USER_PROGRESS = 'UserProgress',
}
